module.exports = __webpack_public_path__ + "img/downloadImages.0dfb5a4f.svg";